import { createTheme } from 'components/base';
import { baseTheme } from './base';

export const createButtonTheme = createTheme({
  palette: baseTheme.palette,
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          fontFamily: 'Roboto',
          fontWeight: 500,
          padding: '5px 16px',
          textTransform: 'none',
        },

        containedPrimary: {
          color: baseTheme.palette.primary.main,
          backgroundColor: baseTheme.palette.secondary.main,
          '&:disabled': {
            backgroundColor: '#F0840F4D !important',
            color: '#5F6D83 !important',
          },
        },
        outlinedPrimary: {
          color: baseTheme.palette.secondary.main,
          border: `1px solid ${baseTheme.palette.secondary.main}`,
          '&:hover': {
            border: `1px solid ${baseTheme.palette.secondary.main}`,
          },
        },
        containedSecondary: {
          color: baseTheme.palette.primary.contrastText,
          border: `1px solid ${baseTheme.palette.primary.dark}`,
          backgroundColor: baseTheme.palette.primary.main,
          '&:hover': {
            border: `1px solid ${baseTheme.palette.primary.dark}`,
            backgroundColor: baseTheme.palette.primary.main,
            color: baseTheme.palette.primary.contrastText,
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        outlinedSecondary: {
          color: baseTheme.palette.primary.main,
          border: '1px solid #23375952',
          '&:hover': {
            border: '1px solid #23375952',
            backgroundColor: '#0000000D',
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        textSecondary: {
          color: baseTheme.palette.primary.main,
          border: 'none',
          backgroundColor: baseTheme.palette.primary.contrastText,
          '&:hover': {
            border: 'none',
            backgroundColor: '#0000000D',
            color: baseTheme.palette.primary.main,
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        textPrimary: {
          color: baseTheme.palette.secondary.main,
          border: 'none',
          backgroundColor: 'transparent !important',
          '&:hover': {
            border: 'none',
            backgroundColor: 'transparent !important',
            color: baseTheme.palette.secondary.main,
          },
          '&:disabled': {
            backgroundColor: '#0000001F !important',
            color: '#9E9E9EE5 !important',
          },
        },
        containedError: {
          '&:disabled': {
            backgroundColor: '#f4433640 !important',
            color: '#5F6D83 !important',
          },
        },
      },
    },
  },
});
